import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/Users/brentvatne/coding/react-native-action-sheet/src/connectActionSheet.tsx";
import * as React from 'react';
import { Consumer } from './context';
export default function connectActionSheet(WrappedComponent) {
  return function (props) {
    return React.createElement(Consumer, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 9
      }
    }, function (_ref) {
      var showActionSheetWithOptions = _ref.showActionSheetWithOptions;
      return React.createElement(WrappedComponent, _extends({}, props, {
        showActionSheetWithOptions: showActionSheetWithOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      }));
    });
  };
}